import "rapidoc";
import { LayoutColumns } from "@gravity-ui/icons";
import {
  useThemeValue,
  Tab,
  TabList,
  TabProvider,
  Icon,
} from "@gravity-ui/uikit";
import { Helmet } from "react-helmet";
import { useParams, useNavigate } from "react-router-dom";
import { GoatLogo } from "src/components/Icons";
import { DewuLogo, PoizonComLogo, ShihuoLogo } from "src/components/Icons";

import css from "./ApiDocsPage.module.scss";
import { useApiDocsPageTranslate } from "./hooks";

type ApiType = "dewu" | "poizon" | "product-storage" | "goat" | "shihuo";

const API_CONFIGS = {
  dewu: {
    name: "Dewu API",
    specUrl: "/api/dewu/api-json",
    icon: DewuLogo,
  },
  poizon: {
    name: "Poizon API",
    specUrl: "/api/poizon-ru/api-json",
    icon: PoizonComLogo,
  },
  goat: {
    name: "GOAT API",
    specUrl: "/api/goat/docs/json",
    icon: GoatLogo,
  },
  shihuo: {
    name: "Shihuo API",
    specUrl: "/api/shihuo/v3/api-docs",
    icon: ShihuoLogo,
  },
  "product-storage": {
    name: "Product Storage API",
    specUrl: "/api/product-storage/api-json",
    icon: LayoutColumns,
  },
} as const;

const isApiType = (value: string): value is ApiType =>
  Object.keys(API_CONFIGS).includes(value);

export const ApiDocsPage = () => {
  const theme = useThemeValue();
  const { tab } = useParams<{ tab?: string }>();
  const navigate = useNavigate();
  const { title, comingSoonTitle, comingSoonText } = useApiDocsPageTranslate();

  const activeApi = tab && isApiType(tab) ? tab : "dewu";

  const currentApiConfig = API_CONFIGS[activeApi];

  const handleTabChange = (value: string) => {
    navigate(`/lk/api-docs/${value}`, { replace: true });
  };

  return (
    <div className={css.divMargin}>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <div className={css.tabsContainer}>
        <TabProvider value={activeApi} onUpdate={handleTabChange}>
          <TabList>
            {Object.entries(API_CONFIGS).map(([key, config]) => (
              <Tab key={key} value={key}>
                <div className={css.tabContent}>
                  <Icon data={config.icon} size={20} />
                  <span>{config.name}</span>
                </div>
              </Tab>
            ))}
          </TabList>
        </TabProvider>
      </div>

      <div className={css.docsContainer}>
        {"comingSoon" in currentApiConfig ? (
          <div className={css.comingSoon}>
            <Icon data={currentApiConfig.icon} size={48} />
            <h2>{comingSoonTitle}</h2>
            <p>{comingSoonText}</p>
          </div>
        ) : (
          <rapi-doc
            theme={theme}
            show-header="false"
            allow-server-selection="false"
            spec-url={currentApiConfig.specUrl}
            render-style="read"
            schema-expand-level="1"
            default-schema-tab="schema"
          />
        )}
      </div>
    </div>
  );
};
